(function (document, $) {
    'use strict';
    addEventListener("DOMContentLoaded", function () {

        var champLinksContainer = document.querySelector(".champ-link");

        var onChampClick = function (e) {
            var link = e.target;

            if (link.href && window.location.href !== link.href) {
                history.pushState({ 'champ': link.href.hash }, null, link.href);
            }
        };

        var setActiveChamp = function () {
            var activeChamp = champLinksContainer.querySelector('a[href="' + window.location.hash + '"]');

            if (activeChamp) {
                $(activeChamp).tab("show");
            }
        };

        champLinksContainer.addEventListener("click", onChampClick);
        addEventListener('popstate', setActiveChamp);
        setActiveChamp();
    });
}(document, jQuery));
